module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 48\" aria-hidden=\"true\"><defs><style> .cls-112321 { fill: #59c6f3; fill-rule: evenodd; } </style></defs><path class=\"cls-112321\" d=\"M19.55,47.33C23.89,42.64,36,28.64,36,18A18,18,0,1,0,0,18c0,10.65,12.09,24.61,16.45,29.3a2.06,2.06,0,0,0,.71.49,2.05,2.05,0,0,0,1.68,0A2.06,2.06,0,0,0,19.55,47.33Zm6.92-29A8.47,8.47,0,1,1,18,9.84,8.47,8.47,0,0,1,26.47,18.33Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map-pin.svg
// module id = hN6K
// module chunks = 1